import { connect } from 'react-redux';

import CallScreenControls, {
  CallScreenControlsStateProps,
  CallScreenControlsDispatchProps,
} from '../components/CallScreenControls';
import {
  destroySession,
  detachPlugin,
  leaveRoom,
  logout,
  toggleMuteAudio,
  toggleMuteVideo,
  toggleScreenSharing,
} from '../actionCreators';
import { StoreState } from '../reducers';

const mapStateToProps = ({
  call,
}: StoreState): CallScreenControlsStateProps => ({
  muteAudio: call.muteAudio,
  muteVideo: call.muteVideo,
  screenshare: call.screenshare,
});

const mapDispatchToProps: CallScreenControlsDispatchProps = {
  destroySession,
  detachPlugin,
  leaveRoom,
  logout,
  toggleMuteAudio,
  toggleMuteVideo,
  toggleScreenSharing,
};

export default connect(mapStateToProps, mapDispatchToProps)(CallScreenControls);
